var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    [
      _c(
        "template",
        { slot: "header" },
        [_c("Title", { attrs: { title: "Remover cartão de crédito" } })],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "body" }, [
        _c("div", { staticClass: "card-info" }, [
          _c("img", {
            attrs: {
              src: "/static/credit-card/" + _vm.icon + ".svg",
              alt: "Bandeira cc"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "numbers" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.first6.slice(0, 4) + " " + _vm.first6.slice(4, 6)) +
                " "
            ),
            _c("b", [_vm._v("·· ····")]),
            _vm._v("  " + _vm._s(_vm.last4) + "\n      ")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "button",
          {
            staticClass: "btn bg-purple",
            class: { "btn--loading": _vm.preloader },
            attrs: { disabled: _vm.preloader },
            on: { click: _vm.handleCreditCardDelete }
          },
          [_c("span", [_vm._v("Excluir cartão")])]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-outlined",
            class: { "btn--loading": _vm.preloader },
            attrs: { disabled: _vm.preloader },
            on: {
              click: function($event) {
                _vm.$emit("exit")
              }
            }
          },
          [_c("span", [_vm._v("Voltar")])]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0356da6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0356da6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/CreditCards/components/Remove.vue
// module id = null
// module chunks = 